import { SignOutButton } from "@clerk/clerk-react";

import { Button } from "~/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "~/components/ui/card";

/**
 * What a signed-in person without a staff_users row sees.
 *
 * One clear screen, deliberately: not a toast, not a redirect back to sign-in
 * (which loops, because they *are* signed in), and not a blank page. The server
 * enforces this independently on every /admin/* route -- this exists so the
 * user gets an explanation instead of a cascade of failed requests.
 */
export function NoAccess({ email }: { email?: string }) {
  return (
    <div className="grid min-h-screen place-items-center bg-background p-6">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>You don't have access to this dashboard</CardTitle>
          <CardDescription>
            {email ? (
              <>
                <span className="font-medium text-foreground">{email}</span> is signed in, but is
                not a staff account.
              </>
            ) : (
              "This account is signed in, but is not a staff account."
            )}{" "}
            Ask someone on the team to grant you access, then sign in again.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <SignOutButton>
            <Button variant="outline">Sign out</Button>
          </SignOutButton>
        </CardContent>
      </Card>
    </div>
  );
}
